import { render, staticRenderFns } from "./OptionShow.vue?vue&type=template&id=410a5790"
import script from "./OptionShow.vue?vue&type=script&lang=ts"
export * from "./OptionShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports